import { render, staticRenderFns } from "./BrandStore.vue?vue&type=template&id=600a7b7c&scoped=true&"
import script from "./BrandStore.vue?vue&type=script&lang=js&"
export * from "./BrandStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a7b7c",
  null
  
)

export default component.exports